module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_job_banner_variant6_image-be548d8e6a58afd7f6f88134de5f081e.jpg";